import React from 'react'
import { useGlobalContext } from '../Context';
import S from '../../pages/ListDam.module.css'
const moment=require('moment-jalaali')

const SensorHistoryCompare = ({data,data2}) => {
    
    const {DeviceCode,Specs,CreateAt}=JSON.parse(data)
    const {DeviceCode:device,Specs:spec,CreateAt:create}=JSON.parse(data2)
    const pbirth=moment(CreateAt).format('jYYYY-jMM-jDD HH:mm')
    const pbirth2=moment(create).format('jYYYY-jMM-jDD HH:mm')
    
                    

    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();

  return (
    <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <div className="editModalDamCon2 Ani AllFFFF">
        <div className={S.AnimContentLI} data-aos='fade'>
      <table>
        
        <tr>
    <th >مشخصات</th>
    <th>مقدار قدیم</th>
    <th>مقدار جدید</th>
  </tr>
  <tr>
    <td>کد دستگاه </td>
    <td>{DeviceCode}</td>
    <td>{device}</td>
  </tr>
  <tr>
    <td>تاریخ ایجاد</td>
    <td>{pbirth}</td>
    <td>{pbirth2}</td>
  </tr>
  <tr>
    <td>  مشخصات</td>
    <td>{Specs}</td>
    <td>{spec}</td>
  </tr>
  
      </table>
    </div>
    </div>


    </div>
    
  )
}

export default SensorHistoryCompare
